export const TOAST = 'TOAST';
export const SOCKET_TOAST = 'SOCKET_TOAST';
